export const globalMixin = {
  data:()=>({

    // isIphone: !!(navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)),
    isIphone: !!navigator.userAgent.match(/iPhone|iPad|iPod/i),


    SaleStates: {
      Desconocido: '0',
      Pedido: '1',
      Armado: '2',
      Enviado: '3',
      Entregado: '4',
      Cancelado: '5',
    },

    ExternalLinks: {
      Instagram: 'https://www.instagram.com/rapi.super',
      Facebook: 'https://www.facebook.com/rapisuper.lisandrodc.com',
      Twitter: 'http://www.twitter.com/Rapisuper1',
    },

    isLocalhost: window.location.href.includes("http://localhost"),
    // isLocalhost: false,
    CartItems: [],

    Validate: { streetName: true },
    colorAlert:'primary',
    myAlertTitle:'',
    myAlertActive:false,
    valueInput:'',
    ivaOptions: [0, 10.5, 21],
    get siteName() {
      if (this.isLocalhost) {
        return "http://localhost/Rapisuper/"; // localhost
      }
      return "https://rapisuper.lisandrodc.com/"; // web
    },
    get publicPath() {
      if (this.isLocalhost) {
        return this.siteName +'Dual/';
      }
      return this.siteName;
    },

    // static
    defaultNoDataText: 'No hay elementos para mostrar',
  }),

  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    pricing: function (value) {
      if (!value) value = 0;
      return '$'+ value.toFixed(2).replace('.', ',');
    },
  },

  computed: {
  }, // COMPUTED

  // getStock
  // getControlDetailsOfSale
  // getParentsInfo
  // addCategoryToArray
  // arrayToText
  // capitalize
  // checkDBResponse
  // closeLoaderMain
  // closeLoadingOfContainer
  // conectToDB
  // copyObj
  // copyToClipboard
  // comparableStr
  // compareSearch
  // dynamicSort
  // findInArrayByField
  // getBuyerAddress
  // getEmployeeName
  // getFullAddress
  // getFullName
  // getFullReceptionTime
  // getImg
  // getImgDual
  // getRealPrice
  // getRealPriceType
  // getStockColor
  // isAnyUndefined
  // isUndefined
  // myAlert
  // myConfirm
  // myNotify
  // objIsEmpty
  // openLoadingOfContainer
  // openLoaderMain
  // pad
  // pricing
  // renameToLabel
  // removeNoNumber
  // showPrice
  // showPaymentPrediction
  // updateProductStock
  // validateFields
  methods: {
    getConfigDB() {
      const vm = this;
      this.conectToDB({
        file: 'Config', action: 'getConfig', params:  { branchID: 1 },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          vm.$store.dispatch('config/setConfigDB', res.data.data[0]);
        }, error: function(error) { vm.myNotify('danger', 'Error', error); },
      });
    },

    getStock(Prod) {
      if (Prod.hasInfiniteStock) {
        if (Prod.pickUpPlaceHasStock) { return 1000; }
        else { return 0; }
      }
      if (Prod.productParentID) return Math.floor(Prod.productParentStock / Prod.productParentMultiplier);
      return Prod.stock;
    },
    getControlDetailsOfSale(Sale, isList = false) {
      let text = '';
      let content = '';
      content += Sale.boxes        ? `${isList ? '<li>' : ''}${Sale.boxes} Caja${this.isPlural(Sale.boxes)}${isList ? '</li>' : ' | ' }` : '';
      content += Sale.bags         ? `${isList ? '<li>' : ''}${Sale.bags} Bolsa${this.isPlural(Sale.bags)}${isList ? '</li>' : ' | ' }` : '';
      content += Sale.refrigerator ? `${isList ? '<li>' : ''}${Sale.refrigerator} Heladera${this.isPlural(Sale.refrigerator)}${isList ? '</li>' : ' | ' }` : '';
      content += Sale.freezer      ? `${isList ? '<li>' : ''}${Sale.freezer} Freezer${this.isPlural(Sale.freezer)}${isList ? '</li>' : ' | ' }` : '';
      content += Sale.eggs6        ? `${isList ? '<li>' : ''}${Sale.eggs6} media${this.isPlural(Sale.eggs6)} docena${this.isPlural(Sale.eggs6)} de Huevo${this.isPlural(Sale.eggs6)}${isList ? '</li>' : ' | ' }` : '';
      content += Sale.eggs30       ? `${isList ? '<li>' : ''}${Sale.eggs30} maple${this.isPlural(Sale.eggs30)} de Huevo${this.isPlural(Sale.eggs30)}${isList ? '</li>' : ' | ' }` : '';
      content += Sale.coal3        ? `${isList ? '<li>' : ''}${Sale.coal3} Carbón${this.isPlural(Sale.coal3, 'es')} de 3kg${isList ? '</li>' : ' | ' }` : '';
      content += Sale.coal5        ? `${isList ? '<li>' : ''}${Sale.coal5} Carbón${this.isPlural(Sale.coal5, 'es')} de 5kg${isList ? '</li>' : ' | ' }` : '';
      if (content) {
        text += `Contenido: ${isList ? '</br>' : ''}${content}`;
      }
      if (Sale.controlNotes) {
        text += `${isList ? '</br>' : ''}Notas: ${isList ? '</br>' : ''}`;
        text += `${isList ? '<li>' : ''}${Sale.controlNotes}${isList ? '</li>' : ''}`;
      }
      return text;
    },

    isPlural(num, pluralText = 's') {
      if (num == 1) return '';
      return pluralText;
    },

    getParentsInfo(AllCategories) {
      let CategoriesLeft = [];
      let orderedCategories = []
      // Get categories without parent
      for (let Cat of AllCategories) {
        if (Cat.parentID == 0) { orderedCategories.push(Cat);
        } else { CategoriesLeft.push(Cat); }
      }
      // Add categories to parent
      let counter = 0;
      while (CategoriesLeft.length && counter < 100) {
        counter++;
        AllCategories = CategoriesLeft;
        CategoriesLeft = [];
        for (let Cat of AllCategories) {
          // if (Cat.parentID == 72) {
          //   console.log(Cat.name);
          // }
          if (!this.addCategoryToArray(Cat, orderedCategories)) {
            CategoriesLeft.push(Cat);
          }
        }
      } // end while
      if (counter == 100) {
        this.myNotify('danger', 'Error', 'No se pudieron cargar correctamente las subcategorías');
        console.log('Quedaron sin asignar, las siguientes categorías:');
        console.log(CategoriesLeft);
      }
      return orderedCategories;
    },


    addCategoryToArray(newCategory, AllCategories) {
      // ESTA FUNCIÓN SOLO SIRVE PARA ACOMODAR UNA VEZ. NO PARA LLAMAR AL AGREGAR UNO NUEVO
      // ADD TO ARRAY
      let lastItem = false;
      let parentFinded = newCategory.parentID == 0 ? true :false;
      let addItem = false;
      for (let i = 0; i < AllCategories.length; i++) {
        // Walk sons
        if (parentFinded) {
          if (newCategory.parentID != AllCategories[i].parentID) {
            // parentID != parentID
            addItem = true;
          }
        } // if parentFinded
        // find parent
        if (newCategory.parentID == AllCategories[i].id) {
          parentFinded = true;
          newCategory.parentsAmount = AllCategories[i].parentsAmount+1;
          newCategory.parentsList   = AllCategories[i].parentsList +' - '+ AllCategories[i].name;
          if (i == AllCategories.length-1) {
          // last item of list
            addItem = true;
            lastItem = true; // CHECKEAR ESTO
          }
        }
        // add item to array
        if (addItem) {
          AllCategories.splice(i + (lastItem ? 1 : 0), 0, this.copyObj(newCategory));
          return true;
        }
      } // for in AllCategories
      return false;
    },
    arrayToText(array) {
      let msg = '';
      for (var i = 0; i < array.length; i++) {
        if (i != 0) {
          msg += i == array.length-1 ? ' y ' : ', ';
        }
        msg += `"${array[i]}"`;
      }
      return msg;
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    checkDBResponse(res) {
      if (typeof res == 'undefined') {
        console.log('Response UNDEFINED');
        return false;
      }
      if (typeof res.data == 'undefined') {
        console.log('ERROR en PHP1:');
        console.log(res);
        return false;
      }
      if (typeof res.data.data == 'undefined') {
        console.log('ERROR en PHP2:');
        console.log(res.data);
        return false;
      }
      if (res.data.error) {
        console.log('ERROR en DB:');
        console.log(res.data.data);
        return false;
      }
      return true;
    },

    closeLoaderMain() {
      this.$nextTick(() => {
        // setTimeout( ()=> {
          this.$vs.loading.close()
        // }, 2000);
      });
    },

    closeLoadingOfContainer(container) {
      this.$nextTick(() => {
        this.$vs.loading.close(`${container} > .con-vs-loading`);
      });
    },
    conectToDB(Params) {
      if (typeof Params.error == 'undefined') {
        Params.error = function(error) { console.log(error); }
      }
      if (typeof Params.params == 'undefined') {
        Params.params = {};
      }
      let url = this.publicPath +'php/'+ Params.file +'.php';
      let params = Params.params;
      params.action = Params.action;
      this.$http.post(url, params)
        .then(Params.success).catch(Params.error);
    },
    copyObj(obj) {
      // Pay atention, this only copy one level of deepness. It's a "shallow copy"
      return Object.assign({}, obj);
    },
    copyToClipboard(text, msg = '') {
      this.$nextTick(() => {
        // RECORDAR SIEMPRE MANDAR EL FUNC EN FORMATO () =>, no en function(), (por el uso del this)
        var copyText = document.getElementById("copyText");
        copyText.textContent = text;
        copyText.style.display = 'block';
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        copyText.style.display = 'none';

        // notifications
        if (msg != '') {
          this.myNotify('success', 'Éxito', msg);
        }
      }); // nextTick
    },
    comparableStr(str) {
      str = this.removeDiacritics(str).toLowerCase();
      str = str.split('v' ).join('b'  );
      str = str.split('ci').join('si' );
      str = str.split('ce').join('se' );
      str = str.split('z' ).join('s'  );
      str = str.split('h' ).join(''   );
      str = str.split('ñ' ).join('ni' );
      str = str.split('ka').join('ca' );
      str = str.split('ko').join('co' );
      str = str.split('qu').join('k'  );
      str = str.split('q' ).join('k'  );
      str = str.split('ku').join('cu' );
      str = str.split('j' ).join('g'  );
      str = str.split(' de ').join(' ');
      str = str.split(' con ').join(' ');
      return str;
    },
    compareSearch(search, compare) {
      // compare is an array of str to compare
      search = search.split(' ');
      for (let word of search) {
        if (word == '') continue;
        let isFinded = false;
        for (let str of compare) {
          if (str.includes(word)) {
            isFinded = true;
            continue
          }
        }
        if (!isFinded) return false;
      }
      return true;
    },
    dynamicSort(property) {
      var sortOrder = 1;
      if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a,b) {
        var result = (a[property].toUpperCase() < b[property].toUpperCase()) ? -1 : (a[property].toUpperCase() > b[property].toUpperCase()) ? 1 : 0;
        return result * sortOrder;
      }
    },
    findInArrayByField(arr, field, value) {
      for (let i in arr) {
        if (arr[i] == value) return arr[i];
      }
      return false;
    },
    getBuyerAddress(Buyer) {
      if (Buyer.buyerCityID == 0) return '';
      let allFields = ['streetName', 'streetNumber', 'floorAndDepartment', 'extraReferences', 'city', ];
      for (let i in allFields) {
        let realField = Buyer['buyer'+ this.capitalize(allFields[i])];
        if (typeof realField != 'undefined') {
          Buyer[allFields[i]] = realField;
        }
      }
      return this.getFullAddress(Buyer);
    },
    getEmployeeName(employeeID) {
      for (let Employee of this.dataDB.employees) {
        if (Employee.id == employeeID) return Employee.name;
      }
      return '';
    },
    getFullAddress(Address, hiddenParam) {
      if (typeof Address == 'undefined') return '';
      if (Address.cityID == 0) return '';
      // check hidden
      let Hidden = {};
      if (typeof hiddenParam == 'string') Hidden[hiddenParam] = true;
      if (typeof hiddenParam == 'object' /* array */) {
        for (var i = 0; i < hiddenParam.length; i++) {
          Hidden[hiddenParam[i]] = true;
        }
      }
      // Add info
      let fullAddress = `${Address.streetName} ${Address.streetNumber}`;
      fullAddress += !Address.floorAndDepartment ? '' : ` ${Address.floorAndDepartment}`;
      fullAddress += !Address.city || Hidden.city ? '' : `, ${Address.city}`;
      fullAddress += !Address.extraReferences || Hidden.extraReferences ? '' : ` (${Address.extraReferences})`;
      return fullAddress;
    },
    getFullName(User) {
      return `${User.name} ${User.surname}`;
    },
    getFullReceptionTime(Sale) {
      return this.minToHour(Sale.receptionTime) +' a '+ this.minToHour(+Sale.receptionTime + +Sale.receptionTimeRange);
    },

    getImg(path, isStatic = true) {
      let time = isStatic ? '' : '?timestamp=' + new Date().getTime();
      return this.publicPath + path + time;
      // return '/' + path + time;
    },
    getImgDual(file) {
      if (this.isIphone) {
        return this.getImg(`images/catalogue/jpg/${file}.jpg`);
      }
      return this.getImg(`images/catalogue/${file}.webp`);
    },
    getRealPrice(Item) {
      return this.showPrice(+Item.offert ? Item.offert : Item.price)
    },
    getRealPriceFloat(Item) {
      return +Item.offert ? Item.offert : Item.price;
    },
    getRealPriceType(Item) {
      return +Item.offert == 0 ? 'price' : 'offert';
    },
    getStockColor(stock, stockAlert) {
      if(stock == 0) return "danger";
      if(stock <= stockAlert) return "warning";
      if(stock > stockAlert) return "success";
      return 'primary';
    },
    isAnyUndefined(values) {
      for (let i in values) {
        if (this.isUndefined(values[i])) {
          return true;
        }
      }
      return false;
    },
    isUndefined(value) {
      return typeof value === 'undefined';
    },
    myAlert(title, text, color = 'primary', func = ()=>{}){
      this.$vs.dialog({
        color: color,
        title: title,
        text:  text,
        accept: func
      });
    },
    myConfirm(type, title, text) {
      this.$vs.notify({
        title   : title,
        text    : text,
        color   : type,
        position: 'bottom-right'
      })
    },
    myNotify(type, title, text) {
      this.$vs.notify({
        title   : title,
        text    : text,
        color   : type,
        position: 'bottom-right'
      });
    },
    myScrollTo(y = 0, x = 0) {
      // to get element height use el.offsetTop
      window.scrollTo({
        top: y,
        left: x,
        behavior: 'smooth'
      });
    },
    objIsEmpty(object) {
      for(var i in object) {
        return false;
      }
      return true;
    },

    openLoadingOfContainer(container, Params = {}) {
      return;
      if (typeof container == 'undefined') return;
      Params.container = container;
      Params.background = typeof Params.background == 'undefined' ? 'primary' : Params.background;
      Params.color = typeof Params.color == 'undefined' ? '#FFF' : Params.color;
      Params.scale = typeof Params.scale == 'undefined' ? 0.45 : Params.scale;
    },

    openLoaderMain() {
      console.log('abro');
      this.$vs.loading()
    },

    pad(num, size) {
      return ('000000000' + num).substr(-size);
    },

    pricing(num) {
      return '$'+ parseFloat(num).toFixed(2).replace('.', ',');
    },

    renameToLabel(obj, oldName = 'name') {
      for (var i in obj) {
        obj[i]['label'] = obj[i][oldName];
      }
      return obj;
    },

    removeNoNumber(str, isFloat = false) {
      let newStr = '';
      str = str.toString();
      for (let i = 0; i < str.length; i++) {
        if (str[i] == parseInt(str[i])) {
          newStr += str[i];
        } else if ((isFloat && str[i] == ',') || (isFloat && str[i] == '.')) {
          newStr += '.';
          isFloat = false;
        }
      }
      return newStr;
    },

    removeDiacritics(str) {
      // Elimina los diacríticos de un texto excepto si es una "ñ" (ES6)
      return str
        .normalize('NFD')
        .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1")
        .normalize();
    },


    showPrice(num) {
      if (num == '') return 0;
      return parseFloat(num).toFixed(2);
    },

    showPaymentPrediction(prediction) {
      if (prediction == '') return '';
      if (prediction == +prediction) return `(Paga $${prediction})`;
      return '';
    },


    updateProductStock(Params) {
      // required Params: productID, amount, websiteZoneID
      if (!this.$store.state.config.ConfigDB.isStockWorking &&
        Params.websiteZoneID == this.dataDB.StockChangesWebsiteZoneIDs.sale) return;
      Params.reasonID = Params.reasonID ? Params.reasonID : 0;
      Params.notes = Params.notes ? Params.notes : '';
      Params.employeeID = localStorage.userID ? localStorage.userID : 0;
      Params.websiteZoneID = Params.websiteZoneID ? Params.websiteZoneID : 0;
      Params.change = Params.amount;
      Params.date = Params.date ? Params.date : this.getActualDatetimeToDB();
      console.log(Params);
      const vm = this;
      const realParams = this.copyObj(Params);
      this.conectToDB({
        file: 'Stock', action: 'updateProductStock', params: realParams,
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          console.log(res)
          vm.updateProductStock_addStockChange(realParams);
        }, error: function(error) {
          vm.myNotify('danger', 'Error', error);
          console.log('Falló y pruebo de nuevo');
          this.updateProductStock(Params);
        },
      });
    },
    updateProductStock_addStockChange(Params) {
      this.conectToDB({
        file: 'Stock', action: 'addStockChange', params: this.copyObj(Params),
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
        }
      });
    },

    validateFields(Parent, obj) {
      if (this.Buyer.isAdmin) return true;
      let requireds = [];
      for (let prop in obj) {
        if (Parent[prop]) {
          this.Validate[prop] = false;
        } else {
          this.Validate[prop] = true;
          // this.myNotify('error', 'Error', `Falta completar el campo ${obj[prop]}`);
          requireds.push(obj[prop]);
        }
      }
      let msg = this.arrayToText(requireds)
      if (msg) {
        if (requireds.length == 1) {
          alert(`Falta completar el campo: ${msg}`);
        } else {
          alert(`Faltan completar los campos: ${msg}`);
        }
        return false;
      }
      return true;
    },
  }, // METHODS
}
